import React, { useState, useEffect } from "react";
import ExcelJS from "exceljs";
import { Button } from "@material-tailwind/react";
import {
  setBGColor,
  setFont,
  setBorder,
  setAlignment
} from "./partials/styles";

import { useShared } from "../../hooks/useShared";

const headers = [
  { key: "shipping_date", width: 15 },
  { key: "export_type", width: 15 },
  { key: "items", width: 15 },
  { key: "shipping_state", width: 15 },

  { key: "barjasti_total", width: 15 },
  { key: "barjasti_price_per_unit", width: 15 },
  { key: "barjasti_quantity", width: 15 },

  { key: "felt_total", width: 15 },
  { key: "felt_price_per_unit", width: 15 },
  { key: "felt_quantity", width: 15 },

  { key: "rug_total", width: 15 },
  { key: "rug_price_per_unit", width: 15 },

  { key: "rug_quantity", width: 15 },

  { key: "carpet_total", width: 15 },
  { key: "carpet_price_per_unit", width: 15 },
  { key: "carpet_quantity", width: 15 },

  { key: "company_inovice_number", width: 15 },
  { key: "company_contact", width: 25 },
  { key: "company_type", width: 25 },
  { key: "company_name", width: 25 },
  { key: "no", width: 5 }
];

function initTotalData() {
  return {
    carpet_total: 0,
    carpet_quantity: 0,
    carpet_price_per_unit: 0,

    rug_total: 0,
    rug_quantity: 0,
    rug_price_per_unit: 0,

    felt_total: 0,
    felt_quantity: 0,
    felt_price_per_unit: 0,

    barjasti_total: 0,
    barjasti_quantity: 0,
    barjasti_price_per_unit: 0
  };
}

let totalData = initTotalData();

function ExportReport({ v }) {
  console.log(v);

  const { http, com } = useShared();

  const [totalCarpet, setTotalCarpet] = useState(totalData);

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("My Sheet");
  //sheet.properties.defaultRowHeight = 20;

  /*TITLE*/
  const shipping_date = com
    .dateConvert(v?.exports[0]?.shipping_date, false)
    .split("/");
  sheet.mergeCells("A1", "U1");
  sheet.getCell(
    "A1"
  ).value = `جدول ارایه گزارش از صادرات قالین و گلیم سال ( ${shipping_date[0]} ) اتحادیه قالین افغانستان `;
  //sheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
  setBGColor(sheet.getCell("A1"));
  setFont(sheet.getCell("A1"));
  setBorder(sheet.getCell("A1"));
  setAlignment(sheet.getCell("A1"));
  sheet.getRow(1).height = 35;

  /* Header */
  sheet.getRow(2).values = [
    "تاريخ صدور",
    "طريق صدور",
    "نوعيت صادرات",
    "کشور مقصد",
    "ارزش دالری برجسته",
    "قيمت فی متر برجسته",

    "متراژ برجسته",
    " ارزش دالری نمد",
    " قيمت فی متر نمد",

    "متراژ نمد",
    " ارزش دالری گليم",
    " قيمت فی متر گليم",

    "متراژ گليم",
    " ارزش دالری قالين",
    " قيمت فی متر قالين",

    "متراژ قالين",
    "اینوايس نمبر",
    " تماس شرکت",
    "نوع فعاليت شرکت",
    "اسم شرکت",
    "#"
  ];

  let alphabet = [..."ABCDEFGHIJKLMNOPQRSTU"];

  const header = [...alphabet];

  header.map((al, i) => {
    return (header[i] = al + "2");
  });
  console.log(header);

  header.map(key => {
    setBGColor(sheet.getCell(key));
    setBorder(sheet.getCell(key));
    setAlignment(sheet.getCell(key));
  });

  const mergeCells = (s, t, l) => {
    sheet.mergeCells(s + l, t + l);
  };

  const setDataRowStyle = () => {
    alphabet?.map((al, i) => {
      new Array(sheet?.rowCount).fill("").map((e, j, { length }) => {
        const key = al + (j + 1);
        if (j > 1) {
          setBorder(sheet.getCell(key));
          setAlignment(sheet.getCell(key));
        }
        if (j > length - 3) {
          // Last 2 rows
          setBGColor(sheet.getCell(key), "fff176");
          setFont(sheet.getCell(key));
        }
      });
    });
    const rowsLength = sheet?.rowCount;

    //Second last row
    mergeCells("Q", "U", rowsLength - 1);
    setAlignment(sheet.getCell("A" + (rowsLength - 1)), "middle", "right");
    // Last row
    mergeCells("Q", "U", rowsLength);
    mergeCells("A", "P", rowsLength);
    setAlignment(sheet.getCell("A" + rowsLength), "middle", "right");
  };

  sheet.columns = headers;

  const setItemsData = (
    rowData,
    quantity,
    price_per_unit,
    total,
    item,
    nLine
  ) => {
    rowData[quantity] += com.NumberFormatter(item?.quantity) + nLine;

    rowData[price_per_unit] +=
      "$" + com.NumberFormatter(item?.price_per_unit) + nLine;

    rowData[total] +=
      "$" + com.NumberFormatter(item?.quantity * item?.price_per_unit) + nLine;
  };
  const setTotal = async (item, total, quantity, price_per_unit) => {
    totalData[total] += Number(item?.price_per_unit * item?.quantity);
    totalData[quantity] += Number(item?.quantity);
    totalData[price_per_unit] += Number(item?.price_per_unit);

    return totalData;
  };

  const getComma = (length, i) => (i < length - 1 ? ", " : "");
  const getNewLine = (length, i) => (i < length - 1 ? "\r\n " : "");

  const getPhone = company =>
    company?.phone ? company?.phone : company?.owner?.phone;
  const getEmail = company =>
    company?.email ? company?.email : company?.owner?.email;

  const getExports = async () => {
    console.log("getExports");

    let eData = [];
    /*  let totalData1 = totalData
     setTotalCarpet(totalData) */

    v?.exports?.map((d, i) => {
      console.log("d ", d);
      const contact = getPhone(d?.company) + "\n" + getEmail(d?.company);

      let rowData = {
        shipping_date: com?.getDate(d?.shipping_date, "MM/DD/yyyy"),
        export_type: d?.export_type?.label,
        shipping_state: d?.shipping_state?.name_af,
        company_name: d?.from?.name_af,
        company_type: d?.company?.company_type?.label,
        company_contact: contact,
        company_inovice_number: d?.company_inovice_number,

        carpet_quantity: "",
        carpet_price_per_unit: "",
        carpet_total: "",

        rug_quantity: "",
        rug_price_per_unit: "",
        rug_total: "",

        felt_quantity: "",
        felt_price_per_unit: "",
        felt_total: "",

        barjasti_quantity: "",
        barjasti_price_per_unit: "",
        barjasti_total: "",

        no: i + 1,
        items: ""
      };

      /*   setItemsData(rowData, "felt_quantity", "felt_price_per_unit", "felt_total", {
          quantity:0.0,
          price_per_unit:0.0,
        } ) */
      d?.tariff?.items?.map((it, j, { length }) => {
        if (it?.category?.value === 26) {
          setItemsData(
            rowData,
            "carpet_quantity",
            "carpet_price_per_unit",
            "carpet_total",
            it,
            getNewLine(length, j)
          );
          setTotal(
            it,
            "carpet_total",
            "carpet_quantity",
            "carpet_price_per_unit"
          );
        } else if (it?.category?.value === 27) {
          setItemsData(
            rowData,
            "rug_quantity",
            "rug_price_per_unit",
            "rug_total",
            it,
            getNewLine(length, j)
          );
          setTotal(it, "rug_total", "rug_quantity", "rug_price_per_unit");
        } else if (it?.category?.value === 28) {
          setItemsData(
            rowData,
            "felt_quantity",
            "felt_price_per_unit",
            "felt_total",
            it,
            getNewLine(length, j)
          );
          setTotal(it, "felt_total", "felt_quantity", "felt_price_per_unit");
        } else if (it?.category?.value === 93) {
          setItemsData(
            rowData,
            "barjasti_quantity",
            "barjasti_price_per_unit",
            "barjasti_total",
            it,
            getNewLine(length, j)
          );
          setTotal(
            it,
            "barjasti_total",
            "barjasti_quantity",
            "barjasti_price_per_unit"
          );
        } else {
        }

        const itype = it?.item_type ? ` (${it?.item_type}) ` : "";
        rowData["items"] += it?.category?.label + itype + getComma(length, j);
      });
      eData.push(rowData);
    });
    return [eData, totalData];
  };

  const generate = async () => {
    console.log(sheet?.rowCount);

    getExports().then(async res => {
      console.log(res);
      res[0].map(e => sheet.addRow(e));

      await sheet.addRow({
        company_inovice_number: "مجموعه فرعی",
        carpet_total: "$" + com.NumberFormatter(totalCarpet?.carpet_total),

        carpet_price_per_unit:
          "$" + com.NumberFormatter(totalCarpet?.carpet_price_per_unit),
        carpet_quantity: com.NumberFormatter(totalCarpet?.carpet_quantity),

        rug_total: "$" + com.NumberFormatter(totalCarpet?.rug_total),

        rug_price_per_unit:
          "$" + com.NumberFormatter(totalCarpet?.rug_price_per_unit),
        rug_quantity: com.NumberFormatter(totalCarpet?.rug_quantity),

        felt_total: "$" + com.NumberFormatter(totalCarpet?.felt_total),

        felt_price_per_unit:
          "$" + com.NumberFormatter(totalCarpet?.felt_price_per_unit),
        felt_quantity: com.NumberFormatter(totalCarpet?.felt_quantity),

        barjasti_total: "$" + com.NumberFormatter(totalCarpet?.barjasti_total),

        barjasti_price_per_unit:
          "$" + com.NumberFormatter(totalCarpet?.barjasti_price_per_unit),
        barjasti_quantity: com.NumberFormatter(totalCarpet?.barjasti_quantity)
      });

      sheet.addRow({
        company_inovice_number: "مجموعه ارزش دالري",
        shipping_date:
          "$" +
          com.NumberFormatter(
            totalCarpet?.carpet_total +
              totalCarpet?.rug_total +
              totalCarpet?.felt_total +
              totalCarpet?.barjasti_total
          )
      });

      if (sheet?.rowCount > 4) {
        setDataRowStyle();
        workbook.xlsx.writeBuffer().then(function(data) {
          const blob = new Blob([data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement("a");
          anchor.href = url;
          anchor.download = "report.xlsx";
          anchor.click();
          window.URL.revokeObjectURL(url);
          v?.setGenerateExcel(false);

          totalData = initTotalData();
        });
      }
    });
  };

  useEffect(() => {
    if (v?.generateExcel) generate();
  }, []);

  /*  return (
     <div>
       <Button onClick={generate}>Generate</Button>
     </div>
   ); */
}

export default ExportReport;
